import { render, staticRenderFns } from "./DataRange.vue?vue&type=template&id=22fc0981"
import script from "./DataRange.vue?vue&type=script&lang=js"
export * from "./DataRange.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports